import $ from 'jquery'

export function scrollToPanel(id) {
  const panel = $(id)
  panel.collapse('show')
  $('html, body').animate({scrollTop: panel.offset().top - 150}, 500)
}

export default {
  init(id) {
    $(`#${id}`).on('show.bs.collapse', function(event) {
      if (history && history.pushState) {
        history.replaceState(null, null, '#' + event.target.id)
      } else {
        window.location.hash = event.target.id
      }
    })

    // if page has link that leads to the info panels we need to handle it
    $('a[href*="#info-panel-"]:not(".info-header")').on('click', function(event) {
      event.preventDefault()
      scrollToPanel(event.target.hash)
    })

    if (window.location.hash.indexOf('#info-panel-') === 0) {
      scrollToPanel(window.location.hash)
    }
  }
}
